import { get } from "@/utilities/querySelector";
import { textToHTML } from "@/utilities/textToHtml";

/**
 * Replace <img> tags with SVG content dynamically using jQuery.
 *
 *
 * This function targets all <img> tags with the class 'svg' and replaces them.
 * It preserves the ID, class, and size attributes of the original <img> tag.
 */
const imgSvgs = /** @type {NodeListOf<HTMLImageElement>} */( document.querySelectorAll( 'img.svg' ) );
imgSvgs.forEach( function( img ) {
    const id = img.id;
    const classList = img.classList.toString();
    const url = img.src;
    const ext = url.split( '.' ).pop();
    if ( ext !== 'svg' ) return;

    fetch( url ).then( async ( res ) => {
        const svgString = await res.text();
        const svg = textToHTML( svgString );
        if ( !svg ) return;

        if ( id ) svg.id = id;
        if ( classList ) svg.setAttribute( 'class', classList );
        svg.classList.add( 'replace-svg' );
        const height = svg.getAttribute( 'height' );
        const width = svg.getAttribute( 'width' );
        if ( !svg.getAttribute( 'viewBox' ) && height && width ) {
            svg.setAttribute( 'viewBox', `0 0 ${height} ${width}` );
        }

        img.replaceWith( svg );
    } ).catch( e => {
        console.warn( e );
    } );
} );

/**
 * When an element with the back-to-top class is clicked, animate
 * the user to scroll them back to the top of the page.
 */
document.querySelector( '.back-to-top' )?.addEventListener( 'click', () => {
    document.documentElement.scrollTo( { top: 0, behavior: 'smooth' } );
} );


/**
 * Show / Hide specific elements when a specific scroll point is hit in the viewport
 *
 * @param {string} elementSelector
 * @param {string} targetSelector
 * @param {string} action
 */
function hideElementAtScroll(elementSelector, targetSelector, action = 'hide') {
    window.addEventListener('scroll', () => {
        const button = get(elementSelector);
        const element = get(targetSelector);

        if (!button || !element) return;

        const rect = element.getBoundingClientRect();
        const isInViewport = rect.top <= (window.innerHeight || document.documentElement.clientHeight);

        if (action === 'hide') {
            button.style.opacity = isInViewport ? '0' : '1';
        } else if (action === 'show') {
            button.style.opacity = isInViewport ? '1' : '0';
        }
    });
}

hideElementAtScroll('[data-fixed-call-to-action]', '[data-footer-main]');
hideElementAtScroll('[data-back-to-top]', '[data-footer-main]', 'show');
